module.exports = __webpack_public_path__ + "img/2.5cd39273.png";